module.exports = __webpack_public_path__ + "static/media/terminos-y-condiciones-wom-octubre2020.12f9e933.pdf";